import React, { useState } from 'react';
import { Card, CardContent, Typography, TextField, Button, Stack, CircularProgress, Chip } from '@mui/material';
import { AppColors } from '../../../../../../Utils/helper/AppColors';
import { validateUserEmail , validateUserEmailSmallCase } from '../../../../../../Utils/helper/commonUtils';
// import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const UserAuthCard = ({ onBack, onNext, loading, email: userEmail }) => {
	const [email, setEmail] = useState(userEmail || '');
	const [emailError, setEmailError] = useState(null);

	const setError = (e) => {
		if (!validateUserEmailSmallCase(e.target.value)) {
			setEmailError('Please enter a valid email');
		} else {
			setEmailError(null);
		}
	};

	const handleSubmit = () => {
		if (!email) {
			setEmailError('Email is required');
			return;
		}

		setEmailError(null);
		onNext(email);
	};

	return (
		<Card sx={{ borderRadius: 3, boxShadow: 2, width: '100%' }}>
			<CardContent sx={{ width: '100%' }}>
				<Stack sx={{ px: { sm: 1, md: 3 } }}>
					<Typography
						sx={(theme) => ({ fontSize: { sm: '24px', md: '32px' }, fontWeight: 700, color: theme.palette.secondary.main })}
						mb={2}
					>
						{/* User Authentication */}Enter email id
					</Typography>
					<Typography sx={(theme) => ({ fontSize: { sm: '16px', md: '18px' }, fontWeight: 400, color: '#777777' })} mb={5}>
						Please enter your email to proceed.
					</Typography>
				</Stack>

				<Typography
					sx={{ px: { sm: 2, md: 4 }, fontSize: { sm: '12px', md: '14px' }, fontWeight: 500, color: '#777777', mb: '16px' }}
				>
					Enter your email address
				</Typography>
				<Stack direction={{ sm: "column", md: "row" }} gap={2} mb={5} sx={{ px: { sm: 1, md: 3 } }}>
					<TextField
						// required
						label="Email"
						name="email"
						placeholder="userAdmin@gmail.com"
						disabled={loading}
						onBlur={setError}
						value={email}
						error={!!emailError}
						helperText={emailError}
						onChange={(e) => {
							const sanitizedValue = e.target.value.replace(/\s/g, '').toLowerCase(); // Remove all spaces
							setEmail(sanitizedValue);
						}}
						size="small"
						fullWidth
						InputLabelProps={{
							// shrink: true,
							sx: { color: AppColors.HEADING_TITLE4 },
						}}
						sx={(theme) => ({
							width: { sm: '100%', md: '100%' },
							'& .MuiOutlinedInput-root': {
								'& fieldset': {
									borderColor: theme.palette.primary.lightest_shade,
									borderRadius: '10px',
								},
								'&:hover fieldset': {
									borderColor: theme.palette.primary.lightest_shade,
									borderRadius: '10px',
								},
								'&.Mui-focused fieldset': {
									borderColor: theme.palette.primary.lightest_shade,
									borderRadius: '10px',
								},
								'& .MuiInputBase-input': {
									paddingTop: '7.5px',
									paddingBottom: '7.5px', // <-- Add this line
								},
							},
						})}
					/>

					<Button
						variant="contained"
						color="info"
						sx={(theme) => ({
							width: { sm: '100px' , md: '150px' },
							'&.Mui-disabled': {
								backgroundColor: theme.palette.primary.primary_shade,
								color: AppColors.WHITE,
								opacity: 0.5,
								border: `1px solid ${theme.palette.primary.lightest_shade}`,
							},
						})}
						onClick={handleSubmit}
						disabled={loading  || !email || !validateUserEmailSmallCase(email)}
					>
						{loading ? 'Verifying...' : 'Verify'}
					</Button>
				</Stack>
				<Stack direction="row" justifyContent="space-between" gap={2} px={1}>
					<Button variant="outlined" color="info" onClick={onBack} disabled={loading}>
						Back
					</Button>

					{/* <Button
						variant="contained"
						color="info"
						onClick={handleSubmit}
						disabled={loading}
						endIcon={loading && <CircularProgress size={20} color="inherit" />}
					>
						{loading ? 'Sending OTP...' : 'Send OTP'}
					</Button> */}
				</Stack>
			</CardContent>
		</Card>
	);
};

export default UserAuthCard;
